import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { T, t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import Typography from '@material-ui/core/Typography';
import ToolbarList from '@configuratorware/configurator-frontendgui/App/Shared/Components/ToolbarList';
import { green, white } from '../Screens/Colors';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flexGrow: 1,
    },
    grow: {
      flexGrow: 1,
    },
    header: {
      minHeight: '64px',
      display: 'flex',
      justifyContent: 'center',
      boxShadow: 'none',
      flexDirection: 'row',
      paddingLeft: 24,
      paddingRight: 24,
      background: white,
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'row-reverse',
        paddingLeft: 16,
        paddingRight: 16,
      },
    },
    title: {
      flex: 1,
      alignContent: 'center',
      fontSize: 'clamp(1rem, 4vw, 2rem)',
    },
    titlePart1: {
      color: green,
    },
    toolbarHeaderWrapper: {
      minHeight: 64,
      padding: 0,
      [theme.breakpoints.down('xs')]: {
        marginRight: 16,
      },
    },
    hiddenEmailShareIframe: {
      visibility: 'hidden',
      position: 'absolute',
    },
    itemIdentifierLabel: {
      fontSize: 15,
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    itemIdentifier: {
      fontWeight: 'bold',
      fontSize: 15,
      marginLeft: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    itemIdentifierContainer: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'flex',
      flexDirection: 'row',
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
  {
    name: 'Header',
  }
);

const Header = (props) => {
  const classes = useStyles(props);
  const { tools } = props;

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className={clsx(classes.header, customClassName('header'))}>
        <Typography variant="h4" className={classes.title}>
          <span className={classes.titlePart1}>{T('itemOverview.title1')}</span>
          {T('itemOverview.title2')}
        </Typography>
        <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>
          <ToolbarList tools={tools} />
        </Toolbar>
      </AppBar>
    </div>
  );
};

Header.propTypes = {
  tools: PropTypes.array,
};

export default Header;
